// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__wIDGm","infoBtn":"quickbooks_infoBtn__2sgP2","formBox":"quickbooks_formBox__2N_qW","formFooter":"quickbooks_formFooter__2RGaY"};